import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SuperAdminAuthProvider } from "./context/SuperAdminAuthContext";
import { SuperAdminTenantProvider } from "./context/SuperAdminTenantContext";
import { SuperAdminProtectedRoute } from "./components/SuperAdminProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import SALogin from "./pages/SALogin";
import SAHome from "./pages/SAHome";
import SATenants from "./pages/SATenants";
import SAAdmins from "./pages/SAAdmins";
import SAAudit from "./pages/SAAudit";
import SALoginActivity from "./pages/SALoginActivity";
import SAStorage from "./pages/SAStorage";
import SAUsage from "./pages/SAUsage";
import SAInsights from "./pages/SAInsights";
import SAImpersonationLog from "./pages/SAImpersonationLog";
import SAAlerts from "./pages/SAAlerts";
import SASettings from "./pages/SASettings";
import SAAiGateway from "./pages/SAAiGateway";
import SAPerformance from "./pages/SAPerformance";
import SASsoKeys from "./pages/SASsoKeys";
import SASchemaDrift from "./pages/SASchemaDrift";
import SABackups from "./pages/SABackups";

const P = (feature, el) => (
  <SuperAdminProtectedRoute feature={feature}>
    <SuperAdminTenantProvider>{el}</SuperAdminTenantProvider>
  </SuperAdminProtectedRoute>
);

export default function SuperAdminApp() {
  return (
    <SuperAdminAuthProvider>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="login" element={<SALogin />} />
        <Route path="" element={P(null, <SAHome />)} />
        <Route path="tenants" element={P("tenants", <SATenants />)} />
        <Route path="admins" element={P("admins", <SAAdmins />)} />
        <Route path="audit" element={P("audit", <SAAudit />)} />
        <Route path="login-activity" element={P("login_activity", <SALoginActivity />)} />
        <Route path="storage" element={P("storage", <SAStorage />)} />
        <Route path="usage" element={P("usage", <SAUsage />)} />
        <Route path="insights" element={P("insights", <SAInsights />)} />
        <Route path="impersonation-log" element={P(null, <SAImpersonationLog />)} />
        <Route path="alerts" element={P("alerts", <SAAlerts />)} />
        <Route path="ai-gateway" element={P("ai_gateway", <SAAiGateway />)} />
        <Route path="performance" element={P("performance", <SAPerformance />)} />
        <Route path="sso-keys" element={P("sso_keys", <SASsoKeys />)} />
        <Route path="schema-drift" element={P("schema_drift", <SASchemaDrift />)} />
        <Route path="backups" element={P("backups", <SABackups />)} />
        <Route path="settings" element={P("settings", <SASettings />)} />
        <Route path="*" element={<Navigate to="/superadmin" replace />} />
      </Routes>
    </SuperAdminAuthProvider>
  );
}
